import * as z from "zod";

export const reviewSchema = z.object({
    rating: z.number().min(1).max(5),
    title: z.string().min(1).max(100),
    text: z.string().min(1).max(5000),
    name: z.string().min(1).max(100),
    userId: z.string().min(1).max(100)
  })

  export const reviewSchemaWithUserId = z.object({
    rating: z.number().min(1).max(5),
    title: z.string().min(1).max(100),
    text: z.string().min(1).max(5000),
    name: z.string().min(1).max(100),
    userId: z.string().min(1).max(100),
    origin: z.string().min(1).max(100),
    reviewerUserId: z.string().min(1).max(100).optional()
  })

  export const renderImageSchema = z.object({
    review: z.object({
      id: z.number().min(1),
      userId: z.string().min(1).max(100),
      reviewerUserId: z.string().min(1).max(100).optional().nullable(),
      userProductId: z.number().min(1).optional().nullable(),
      rating: z.number().min(1).max(5).optional(),
      title: z.string().min(1).max(100).optional(),
      text: z.string().min(1).max(5000).optional(),
      name: z.string().min(1).max(100).optional(),
      date: z.date().optional().nullable(),
      userReviewImportId: z.number().min(1).optional().nullable(),
      origin: z.string().min(1).max(100).optional(),
      status: z.string().min(1).max(100).optional(),
      createdAt: z.string().transform((val) => new Date(val)),
      modifiedAt: z.string().transform((val) => new Date(val)),
      user: z.object({
        name: z.string().min(1).max(100).optional(),
        profileImageUrl: z.string().min(1).max(500).optional(),
      }),
      reviewerUser: z.object({
        name: z.string().min(1).max(100),
        profileImageUrl: z.string().min(1).max(500),
      }).optional().nullable()
    }),
    hexColour: z.string().min(1).max(7),
    className: z.string().optional(),
    backgroundUrl: z.string(),
    cardStyle: z.string(),
    width: z.number(),
    height: z.number()
})

//inputProps={{review, backgroundUrl, cardStyle, hexColour, className, width, height}}

export const praiseSchema = z.object({
    title: z.string().min(1).max(100),
    text: z.string().min(1).max(300),
    name: z.string().min(1).max(100),
    rating: z.number().min(1).max(5),
})

export const praiseSchemaWithUserId = z.object({
    title: z.string().min(1).max(100),
    text: z.string().min(1).max(300),
    name: z.string().min(1).max(100),
    rating: z.number().min(1).max(5),
    reviewerUserId: z.string().min(1).max(100).optional(),
    userId: z.string().min(1).max(100),
    origin: z.string().min(1).max(100),
})

export const praiseSaveSchema = z.object({
    reviewId: z.number().min(1),
})

export const praiseSaveSchemaAPI = z.object({
    reviewId: z.number().min(1),
})